module.exports = __webpack_public_path__ + "img/radio-checked.3f14dbae.svg";